(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["footer"]) return;
  try {
    
  customElements.whenDefined('details-disclosure').then(() => {
    class FooterMenu extends DetailsDisclosure {
      constructor() {
        super();
        this.reset(false);
        window.addEventListener('on:breakpoint-change', this.reset.bind(this));
      }

      reset() {
        const isLargeScreen = window.matchMedia(theme.mediaQueries.md).matches;
        const isConfirmNewsletter = !isLargeScreen &&
          (window.location.hash === "#footer-signup_form" && this.querySelector('#footer-signup_form') !== null);

        this.disclosure.open = isLargeScreen || isConfirmNewsletter;

        if (isLargeScreen) {
          this.toggle.setAttribute('tabindex', '-1');
        } else {
          this.toggle.removeAttribute('tabindex');
        }
      }
    }

    customElements.define('footer-menu', FooterMenu);
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  customElements.whenDefined('details-disclosure').then(() => {
    class NavMenu extends DetailsDisclosure {
      constructor() {
        super();

        if(this.matches('.js-mega-nav')) {
          this.reset(false);
          window.addEventListener('on:breakpoint-change', this.reset.bind(this));
        }
      }

      reset(resize = true) {
        const isLargeScreen = window.matchMedia(theme.mediaQueries.md).matches;
        this.disclosure.open = isLargeScreen;
        if (isLargeScreen) {
          this.toggle.setAttribute('tabindex', '-1');
        } else {
          this.toggle.removeAttribute('tabindex');
        }
      }

      handleToggle(e) {
        if (!(this.matches('.js-mega-nav') && window.matchMedia(theme.mediaQueries.md).matches)) {
          super.handleToggle(e);
        }
      }
    }

    customElements.define('nav-menu', NavMenu);
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mse-color-wall"]) return;
  try {
    
(() => {
  const initColorWall = (root) => {
    if (!root || root.dataset.mseColorWallReady === 'true') return;
    root.dataset.mseColorWallReady = 'true';

    const refreshCheckoutTotal = () => document.dispatchEvent(new CustomEvent('mse:cart:refresh'));

    const feed = root.querySelector('[data-mse-color-wall-feed]');
    const search = root.querySelector('[data-mse-color-wall-search]');
    const status = root.querySelector('[data-mse-color-wall-status]');
    const empty = root.querySelector('[data-mse-color-wall-empty]');
    const toast = root.querySelector('[data-mse-color-wall-toast]');
    const dekoSection = root.querySelector('[data-mse-deko-section]');
    const dekoFeed = root.querySelector('[data-mse-deko-feed]');
    const actionToggle = root.querySelector('[data-mse-action-toggle]');
    const actionMenu = root.querySelector('[data-mse-action-menu]');
    const actionLabel = root.querySelector('[data-mse-action-label]');
    const actionHint = root.querySelector('[data-mse-action-hint]');
    const actionQuick = root.querySelector('.mse-color-wall__action-quick');
    const actionChoices = Array.from(root.querySelectorAll('[data-mse-action-choice]'));
    const viewButtons = Array.from(root.querySelectorAll('[data-mse-view-columns]'));
    if (!feed) return;

    const sectionId = root.dataset.sectionId;
    const totalPages = Number.parseInt(feed.dataset.totalPages || '1', 10);
    const currentPage = Number.parseInt(feed.dataset.currentPage || '1', 10);
    const storageKey = 'mse_color_wall_click_action_v1';
    const viewStorageKey = 'mse_color_wall_columns_v1';
    let toastTimer;
    let hintTimer;
    let spotlightTimer;
    let spotlightFadeTimer;
    let spotlightRemoveTimer;
    let clickAction = '';

    const getColorGelCartQuantity = async () => {
      try {
        const routeRoot = window.Shopify?.routes?.root || '/';
        const response = await fetch(routeRoot + 'cart.js', { headers: { Accept: 'application/json' } });
        if (!response.ok) return null;
        const cart = await response.json();
        return (cart.items || []).reduce((sum, line) => {
          const sku = String(line?.sku || '').trim();
          if (!/^150[15]/.test(sku)) return sum;
          return sum + Math.max(0, Number.parseInt(line.quantity, 10) || 0);
        }, 0);
      } catch (error) {
        return null;
      }
    };

    const buildCartTierMessage = (count) => {
      if (!Number.isFinite(count)) return '';
      if (count < 100) {
        return root.dataset.tierNextTemplate
          .replace('__COUNT__', String(count))
          .replace('__REMAINING__', String(100 - count));
      }
      if (count < 300) {
        return root.dataset.tierReachedTemplate
          .replace('__COUNT__', String(count))
          .replace('__REMAINING__', String(300 - count));
      }
      return root.dataset.tierBestTemplate.replace('__COUNT__', String(count));
    };

    try {
      clickAction = window.localStorage.getItem(storageKey) || '';
    } catch (error) {
      clickAction = '';
    }

    if (clickAction !== 'cart' && clickAction !== 'product') clickAction = 'cart';

    const selectSearchForNextNumber = () => {
      if (!search || !search.value) return;

      const apply = () => {
        search.focus({ preventScroll: true });
        if (typeof search.select === 'function') search.select();
        try {
          search.setSelectionRange(0, search.value.length);
        } catch (error) {
        }
      };

      window.requestAnimationFrame(apply);
      window.setTimeout(apply, 80);
    };

    const publishEvent = (name, data) => {
      if (!window.Shopify?.analytics?.publish) return;
      const result = window.Shopify.analytics.publish(name, data);
      if (result && typeof result.catch === 'function') result.catch(() => {});
    };

    const spotlightSessionKey = 'mse_color_wall_action_spotlight_seen_v1';

    const hideActionSpotlight = (markSeen = false) => {
      window.clearTimeout(spotlightTimer);
      window.clearTimeout(spotlightFadeTimer);
      window.clearTimeout(spotlightRemoveTimer);
      if (!actionQuick) return;

      if (markSeen) {
        try {
          window.sessionStorage.setItem(spotlightSessionKey, '1');
        } catch (error) {
        }
      }

      actionQuick.classList.add('is-mse-spotlight-fade');
      spotlightRemoveTimer = window.setTimeout(() => {
        actionQuick.classList.remove('is-mse-spotlight', 'is-mse-spotlight-fade');
      }, 600);
    };

    const showActionSpotlight = () => {
      if (!actionQuick) return;

      const params = new URLSearchParams(window.location.search);
      if (params.get('mse_menu') !== 'wall') return;

      let seen = false;
      try {
        seen = window.sessionStorage.getItem(spotlightSessionKey) === '1';
      } catch (error) {
        seen = false;
      }
      if (seen) return;

      spotlightTimer = window.setTimeout(() => {
        actionQuick.classList.remove('is-mse-spotlight-fade');
        actionQuick.classList.add('is-mse-spotlight');

        try {
          window.sessionStorage.setItem(spotlightSessionKey, '1');
        } catch (error) {
        }

        publishEvent('mse:color_wall_action_spotlight_shown', {
          source: 'color_wall',
          mode: 'wall'
        });

        spotlightFadeTimer = window.setTimeout(() => {
          actionQuick.classList.add('is-mse-spotlight-fade');
        }, 2800);

        spotlightRemoveTimer = window.setTimeout(() => {
          actionQuick.classList.remove('is-mse-spotlight', 'is-mse-spotlight-fade');
        }, 3500);
      }, 550);
    };

    const closeActionMenu = () => {
      if (actionMenu) actionMenu.hidden = true;
      if (actionToggle) actionToggle.setAttribute('aria-expanded', 'false');
    };

    const openActionMenu = () => {
      if (actionMenu) actionMenu.hidden = false;
      if (actionToggle) actionToggle.setAttribute('aria-expanded', 'true');
      if (actionHint) actionHint.hidden = true;
      window.clearTimeout(hintTimer);
    };

    const setClickAction = (action, persist = false) => {
      clickAction = action === 'cart' || action === 'product' ? action : '';
      root.dataset.mseClickAction = clickAction || 'choose';

      if (actionLabel) {
        actionLabel.textContent = clickAction === 'cart'
          ? root.dataset.actionCartLabel
          : clickAction === 'product'
            ? root.dataset.actionProductLabel
            : root.dataset.actionChooseLabel;
      }

      actionChoices.forEach((choice) => {
        const active = choice.dataset.mseActionChoice === clickAction;
        choice.classList.toggle('is-active', active);
        choice.setAttribute('aria-pressed', active ? 'true' : 'false');
      });

      if (persist && clickAction) {
        try {
          window.localStorage.setItem(storageKey, clickAction);
        } catch (error) {
        }

        publishEvent('mse:color_wall_action_selected', {
          source: 'color_wall',
          action: clickAction
        });
      }
    };

    const setViewColumns = (value, persist = false) => {
      let columns = Number.parseInt(value, 10);
      if (![2, 3, 4, 5].includes(columns)) columns = 5;

      root.style.setProperty('--mse-wall-columns', String(columns));

      viewButtons.forEach((button) => {
        const active = Number.parseInt(button.dataset.mseViewColumns, 10) === columns;
        button.classList.toggle('is-active', active);
        button.setAttribute('aria-pressed', active ? 'true' : 'false');
      });

      if (persist) {
        try {
          window.localStorage.setItem(viewStorageKey, String(columns));
        } catch (error) {
        }
      }
    };

    let savedViewColumns = 5;
    try {
      savedViewColumns = Number.parseInt(window.localStorage.getItem(viewStorageKey) || '5', 10);
    } catch (error) {
      savedViewColumns = 5;
    }

    setViewColumns(savedViewColumns);
    setClickAction(clickAction);
    showActionSpotlight();

    if (actionHint) {
      window.setTimeout(() => {
        actionHint.hidden = false;
        hintTimer = window.setTimeout(() => {
          if (clickAction) actionHint.hidden = true;
        }, 2800);
      }, 550);
    }

    const itemNumber = (item) => {
      const value = String(item.dataset.number || '').replace(/\D/g, '');
      return Number.parseInt(value || '999999', 10);
    };

    const allItems = () => Array.from(root.querySelectorAll('[data-mse-color-wall-item]'));

    /* MSE_COLOR_WALL_REVIEW_API_V5_STANDARD_STARS_COUNT_20261006
     * Wichtig: NICHT Shopify product.metafields.reviews verwenden.
     * MSE Trust / TraceAmp ist die führende Bewertungsquelle.
     */
    const reviewSummaryCache = new Map();

    const renderReviewSummary = (item, data) => {
      const badge = item.querySelector('[data-mse-color-wall-rating]');
      const stars = item.querySelector('[data-mse-color-wall-rating-stars]');
      const countNode = item.querySelector('[data-mse-color-wall-rating-count]');
      if (!badge || !stars || !countNode) return;

      const count = Number(data?.rating_count) || 0;
      const average = Number(data?.rating_average);
      const rating = Number.isFinite(average) && count > 0
        ? Math.max(0, Math.min(5, average))
        : 0;

      stars.style.setProperty('--rating', String(rating));
      stars.style.setProperty('--rating-max', '5');

      if (count > 0) {
        countNode.textContent = '(' + count + ')';
        countNode.hidden = false;
      } else {
        countNode.textContent = '';
        countNode.hidden = true;
      }

      badge.title = count > 0
        ? rating.toLocaleString(document.documentElement.lang || 'de-DE', {
            minimumFractionDigits: rating % 1 === 0 ? 0 : 1,
            maximumFractionDigits: 1
          }) + ' / 5'
        : '';

      badge.classList.remove('is-loading');
    };

    const loadReviewSummary = async (item) => {
      if (!item || item.dataset.mseReviewLoaded === '1') return;

      const productId = String(item.dataset.productId || '').trim();
      if (!productId) {
        renderReviewSummary(item, null);
        item.dataset.mseReviewLoaded = '1';
        return;
      }

      item.dataset.mseReviewLoaded = '1';

      try {
        let promise = reviewSummaryCache.get(productId);

        if (!promise) {
          promise = fetch(
            'https://traceamp.msebeauty.de/api/reviews/product-id/' +
              encodeURIComponent(productId) +
              '/summary',
            {
              method: 'GET',
              mode: 'cors',
              credentials: 'omit',
              cache: 'no-store',
              headers: { Accept: 'application/json' }
            }
          ).then((response) => {
            if (!response.ok) {
              throw new Error('MSE review API HTTP ' + response.status);
            }
            return response.json();
          });

          reviewSummaryCache.set(productId, promise);
        }

        renderReviewSummary(item, await promise);
      } catch (error) {
        item.dataset.mseReviewLoaded = '0';
        renderReviewSummary(item, null);
      }
    };

    let reviewObserver = null;

    const observeReviewItem = (item) => {
      if (!item || item.dataset.mseReviewObserved === '1') return;
      item.dataset.mseReviewObserved = '1';

      if (!('IntersectionObserver' in window)) {
        loadReviewSummary(item);
        return;
      }

      if (!reviewObserver) {
        reviewObserver = new IntersectionObserver(
          (entries) => {
            entries.forEach((entry) => {
              if (!entry.isIntersecting) return;
              reviewObserver.unobserve(entry.target);
              loadReviewSummary(entry.target);
            });
          },
          { rootMargin: '350px 0px' }
        );
      }

      reviewObserver.observe(item);
    };

    const observeReviewItems = (scope = root) => {
      scope.querySelectorAll('[data-mse-color-wall-item]').forEach(observeReviewItem);
    };

    /* MSE_COLOR_WALL_SWYM_INIT_V1_20261006 */
    const initWishlistButtons = () => {
      const run = (swat) => {
        try {
          swat?.initializeActionButtons?.(
            '.mse-color-wall-shell',
            '.mse-color-wall__wishlist[data-swaction]'
          );
        } catch (error) {
          console.error('MSE Colorwall Wishlist init', error);
        }
      };

      if (window._swat) {
        run(window._swat);
        return;
      }

      window.SwymCallbacks = window.SwymCallbacks || [];

      if (!window.__mseColorWallSwymCallbackAdded) {
        window.__mseColorWallSwymCallbackAdded = true;
        window.SwymCallbacks.push(run);
      }
    };

    const colorOrder = {
      rot: 1,
      orange: 2,
      gelb: 3,
      grün: 4,
      türkis: 5,
      blau: 6,
      violett: 7,
      pink: 8,
      rosa: 9,
      beige: 10,
      braun: 11,
      gold: 12,
      bronze: 12,
      kupfer: 12,
      silber: 13,
      grau: 13,
      weiß: 14,
      schwarz: 15,
      klar: 16
    };

    const itemColorRank = (item) => {
      const baseColor = String(item.dataset.baseColor || '').trim();
      if (item.dataset.series === 'xenova' && baseColor && colorOrder[baseColor]) return colorOrder[baseColor];

      const excludedColors = String(item.dataset.colorExclusions || '')
        .split(',')
        .map((value) => value.trim())
        .filter(Boolean);

      const firstColor = String(item.dataset.colorTags || '')
        .split(',')
        .map((value) => value.trim())
        .find((value) => value && !excludedColors.includes(value));

      return colorOrder[firstColor] || Number(item.dataset.colorRank || 99);
    };

    const organizeDekoItems = () => {
      if (!dekoFeed) return;

      allItems().forEach((item) => {
        const target = item.dataset.isDeko === '1' ? dekoFeed : feed;
        if (item.parentElement !== target) target.appendChild(item);
      });

      if (dekoSection) {
        dekoSection.hidden = !dekoFeed.querySelector('[data-mse-color-wall-item]');
      }
    };

    const sortContainer = (container) => {
      if (!container) return;
      const items = Array.from(container.querySelectorAll('[data-mse-color-wall-item]'));
      items.sort((a, b) => {
        const availableDifference = Number(b.dataset.available || 0) - Number(a.dataset.available || 0);
        if (availableDifference !== 0) return availableDifference;

        const colorDifference = itemColorRank(a) - itemColorRank(b);
        if (colorDifference !== 0) return colorDifference;

        return itemNumber(a) - itemNumber(b);
      });
      items.forEach((item) => container.appendChild(item));
    };

    const sortItems = () => {
      organizeDekoItems();
      sortContainer(feed);
      sortContainer(dekoFeed);
    };

    const dedupe = () => {
      const seen = new Set();
      allItems().forEach((item) => {
        const id = item.dataset.productId;
        if (seen.has(id)) item.remove();
        else seen.add(id);
      });
    };

    const getActiveColorFilters = () => {
      const url = new URL(window.location.href);
      const raw = url.searchParams.get('mse_color') || '';
      return raw
        .split(',')
        .map((value) => value.trim())
        .filter(Boolean);
    };

    const getActiveFinishFilter = () => {
      const url = new URL(window.location.href);
      return String(url.searchParams.get('mse_finish') || '').trim();
    };

    const applySearch = () => {
      const rawTerm = String(search?.value || '').trim().toLowerCase().replace(/^#\s*/, '');
      const numericSearch = /^\d{1,4}$/.test(rawTerm);
      const normalizedTerm = numericSearch ? rawTerm.replace(/^0+(?=\d)/, '') : rawTerm;
      const activeColors = getActiveColorFilters();
      const activeFinish = getActiveFinishFilter();
      let visible = 0;
      let dekoVisible = 0;

      allItems().forEach((item) => {
        const number = String(item.dataset.number || '').toLowerCase().replace(/^#\s*/, '');
        const normalizedNumber = number.replace(/^0+(?=\d)/, '');
        const title = String(item.dataset.title || '').toLowerCase();
        const searchableText = [
          title,
          String(item.dataset.colorTags || ''),
          String(item.dataset.baseColor || ''),
          String(item.dataset.finish || ''),
          String(item.dataset.series || '')
        ].join(' ').toLowerCase();
        const searchMatch = !rawTerm
          || (numericSearch ? normalizedNumber === normalizedTerm : searchableText.includes(rawTerm));

        const itemColors = String(item.dataset.colorTags || '')
          .split(',')
          .map((value) => value.trim())
          .filter(Boolean);
        const excludedColors = String(item.dataset.colorExclusions || '')
          .split(',')
          .map((value) => value.trim())
          .filter(Boolean);
        const baseColor = String(item.dataset.baseColor || '').trim();
        const colorMatch = !activeColors.length || activeColors.some((color) => {
          if (excludedColors.includes(color)) return false;
          if (item.dataset.series === 'xenova' && baseColor === color) return true;
          return itemColors.includes(color);
        });
        const finishMatch = !activeFinish || String(item.dataset.finish || '') === activeFinish;
        const show = searchMatch && colorMatch && finishMatch;

        item.hidden = !show;
        if (show) {
          visible += 1;
          if (item.dataset.isDeko === '1') dekoVisible += 1;
        }
      });

      if (dekoSection) dekoSection.hidden = dekoVisible === 0;
      if (empty) empty.hidden = visible !== 0;
    };

    window.addEventListener('mse:color-filter-change', applySearch);
    window.addEventListener('mse:finish-filter-change', applySearch);

    const updateStatus = (loading = false, sorting = false) => {
      if (!status) return;
      if (loading) status.textContent = root.dataset.loadingLabel;
      else if (sorting) status.textContent = root.dataset.colorSortLabel;
      else status.textContent = `${allItems().length} ${root.dataset.colorsLabel}`;
    };

    const showToast = (message, success = false) => {
      if (!toast) return;
      window.clearTimeout(toastTimer);
      toast.classList.remove('is-tier');
      toast.textContent = message;
      toast.hidden = false;
      toast.classList.toggle('is-success', success);
      toastTimer = window.setTimeout(() => {
        toast.hidden = true;
        toast.classList.remove('is-success', 'is-tier');
      }, 1800);
    };

    const showTierToast = (count) => {
      if (!toast || !Number.isFinite(count)) return false;
      const nextTier = count < 100 ? 100 : 300;
      const remaining = Math.max(0, nextTier - count);
      const nextPrice = count < 100 ? '2,69 €' : '2,31 €';

      window.clearTimeout(toastTimer);
      toast.replaceChildren();
      toast.classList.add('is-success', 'is-tier');
      toast.hidden = false;

      const top = document.createElement('div');
      top.className = 'mse-color-wall__toast-tier-top';
      const countNumber = document.createElement('strong');
      countNumber.className = 'mse-color-wall__toast-tier-number';
      countNumber.textContent = String(count);
      const countLabel = document.createElement('span');
      countLabel.className = 'mse-color-wall__toast-tier-label';
      countLabel.textContent = root.dataset.cartCountLabel;
      top.append(countNumber, countLabel);
      toast.append(top);

      if (count < 300) {
        const middle = document.createElement('div');
        middle.className = 'mse-color-wall__toast-tier-middle';
        const remainingNumber = document.createElement('strong');
        remainingNumber.className = 'mse-color-wall__toast-tier-number mse-color-wall__toast-tier-number--missing';
        remainingNumber.textContent = String(remaining);
        const missingLabel = document.createElement('span');
        missingLabel.className = 'mse-color-wall__toast-tier-missing';
        missingLabel.textContent = root.dataset.tierMissingLabel;
        middle.append(remainingNumber, missingLabel);
        toast.append(middle);

        const priceLine = document.createElement('div');
        priceLine.className = 'mse-color-wall__toast-tier-price';
        priceLine.textContent = root.dataset.tierPriceTemplate.replace('__PRICE__', nextPrice);
        toast.append(priceLine);
      } else {
        const best = document.createElement('div');
        best.className = 'mse-color-wall__toast-tier-best';
        best.textContent = root.dataset.tierBestLabel;
        toast.append(best);

        const priceLine = document.createElement('div');
        priceLine.className = 'mse-color-wall__toast-tier-price';
        priceLine.textContent = root.dataset.tierBestPrice;
        toast.append(priceLine);
      }

      toastTimer = window.setTimeout(() => {
        toast.hidden = true;
        toast.classList.remove('is-success', 'is-tier');
      }, 1800);
      return true;
    };

    const appendPage = async (page) => {
      const url = new URL(window.location.href);
      url.searchParams.set('page', String(page));
      url.searchParams.set('section_id', sectionId);
      const response = await fetch(url.toString(), { headers: { Accept: 'text/html' } });
      if (!response.ok) throw new Error(String(response.status));
      const html = await response.text();
      const doc = new DOMParser().parseFromString(html, 'text/html');
      const remoteFeed = doc.querySelector('[data-mse-color-wall-feed]');
      if (!remoteFeed) return;
      remoteFeed.querySelectorAll('[data-mse-color-wall-item]').forEach((item) => {
        feed.appendChild(item);
        observeReviewItem(item);
      });
      initWishlistButtons();
    };

    const loadAllPages = async () => {
      if (totalPages <= 1) {
        sortItems();
        applySearch();
        updateStatus(false);
        return;
      }

      updateStatus(true);
      const pages = [];
      for (let page = 1; page <= totalPages; page += 1) {
        if (page !== currentPage) pages.push(page);
      }

      try {
        for (let index = 0; index < pages.length; index += 2) {
          await Promise.all(pages.slice(index, index + 2).map(appendPage));
          dedupe();
          sortItems();
          applySearch();
        }
      } catch (error) {
        console.error(error);
      } finally {
        dedupe();
        sortItems();
        applySearch();
        updateStatus(false);
      }
    };

    search?.addEventListener('input', applySearch);

    root.addEventListener('click', async (event) => {
      const viewButton = event.target.closest('[data-mse-view-columns]');
      if (viewButton && root.contains(viewButton)) {
        setViewColumns(viewButton.dataset.mseViewColumns, true);
        return;
      }

      const actionChoice = event.target.closest('[data-mse-action-choice]');
      if (actionChoice && root.contains(actionChoice)) {
        hideActionSpotlight(true);
        setClickAction(actionChoice.dataset.mseActionChoice, true);
        closeActionMenu();
        if (actionHint) actionHint.hidden = true;
        return;
      }

      const actionButton = event.target.closest('[data-mse-action-toggle]');
      if (actionButton && root.contains(actionButton)) {
        if (actionMenu?.hidden) openActionMenu();
        else closeActionMenu();
        return;
      }

      const wishlistButton = event.target.closest('.mse-color-wall__wishlist');
      if (wishlistButton && root.contains(wishlistButton)) return;

      const item = event.target.closest('[data-mse-color-wall-item]');
      if (!item || !root.contains(item)) return;

      const number = item.dataset.number || '';

      if (!clickAction) {
        openActionMenu();
        return;
      }

      if (clickAction === 'product') {
        publishEvent('mse:color_wall_product_open', {
          source: 'color_wall',
          productId: item.dataset.productId,
          variantId: item.dataset.variantId,
          number
        });
        window.location.assign(item.dataset.productUrl);
        return;
      }

      if (item.dataset.available !== '1') {
        showToast(root.dataset.soldOutTemplate.replace('__NUMBER__', number));
        return;
      }

      if (item.classList.contains('is-adding')) return;
      item.classList.add('is-adding');
      const tapButton = item.querySelector('[data-mse-color-wall-tap]');
      if (tapButton) tapButton.disabled = true;
      const checkoutButton = root.querySelector('[data-mse-color-wall-checkout]');
      if (checkoutButton) checkoutButton.disabled = true;

      try {
        const routeRoot = window.Shopify?.routes?.root || '/';
        const cartDrawer = document.querySelector('cart-drawer');
        const cartDrawerSection = cartDrawer
          ?.closest('.shopify-section')
          ?.id
          ?.replace('shopify-section-', '');
        const sections = ['cart-icon-bubble'];
        if (cartDrawerSection) sections.push(cartDrawerSection);

        const response = await fetch(routeRoot + 'cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({
            items: [{ id: Number(item.dataset.variantId), quantity: 1 }],
            sections: sections.join(','),
            sections_url: window.location.pathname
          })
        });
        if (!response.ok) throw new Error(String(response.status));

        const data = await response.json();
        const cartIconBubble = document.getElementById('cart-icon-bubble');
        refreshCheckoutTotal();
        if (cartIconBubble && data.sections?.['cart-icon-bubble']) {
          const template = document.createElement('template');
          template.innerHTML = data.sections['cart-icon-bubble'];
          const remoteSection = template.content.querySelector('.shopify-section');
          cartIconBubble.innerHTML = remoteSection ? remoteSection.innerHTML : data.sections['cart-icon-bubble'];
        }

        if (cartDrawer && cartDrawerSection && data.sections?.[cartDrawerSection]) {
          cartDrawer.renderContents(data, false);
        } else {
          document.dispatchEvent(new CustomEvent('dispatch:cart-drawer:refresh'));
        }

        publishEvent('mse:color_wall_add', {
          source: 'color_wall',
          productId: item.dataset.productId,
          variantId: item.dataset.variantId,
          number
        });

        const colorGelCount = await getColorGelCartQuantity();
        if (!showTierToast(colorGelCount)) {
          showToast(root.dataset.addedTemplate.replace('__NUMBER__', number), true);
        }
        selectSearchForNextNumber();
      } catch (error) {
        showToast(root.dataset.errorLabel);
      } finally {
        if (tapButton) tapButton.disabled = false;
        item.classList.remove('is-adding');
        if (checkoutButton) checkoutButton.disabled = Boolean(root.querySelector('.is-adding'));
      }
    });

    organizeDekoItems();
    sortItems();
    applySearch();
    observeReviewItems();
    initWishlistButtons();
    updateStatus(totalPages > 1);

    if ('requestIdleCallback' in window) window.requestIdleCallback(loadAllPages, { timeout: 900 });
    else window.setTimeout(loadAllPages, 250);
  };

  const initAllColorWalls = () => {
    document.querySelectorAll('[data-mse-color-wall]').forEach(initColorWall);
  };

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initAllColorWalls, { once: true });
  else initAllColorWalls();

  document.addEventListener('shopify:section:load', initAllColorWalls);
})();

  } catch(e) { console.error(e); }
})();
})();
